import React, { FC } from "react";

type IProps = {
  width?: string;
  height?: string;
  color?: string;
};

const BigPlay: FC<IProps> = ({ width, height, color }) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="60" height="60" rx="30" fill="#FD8533" />
      <path
        d="M39.6008 27.9055C41.2008 28.8364 41.2008 31.1636 39.6008 32.0945L25.2008 40.4724C23.6008 41.4032 21.6008 40.2396 21.6008 38.3779L21.6008 21.6221C21.6008 19.7603 23.6008 18.5967 25.2008 19.5276L39.6008 27.9055Z"
        fill="white"
      />
    </svg>
  );
};

export default BigPlay;
